import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import PropTypes from 'prop-types';
var withGoogleMaps = function withGoogleMaps(Wrapped) {
  var WithGoogleMaps = function WithGoogleMaps(props, context) {
    var _context$__ais_geo_se = context.__ais_geo_search__google_maps__,
      google = _context$__ais_geo_se.google,
      instance = _context$__ais_geo_se.instance;
    return React.createElement(Wrapped // @TODO: remove the cast once TypeScript fixes the issue
    // https://github.com/Microsoft/TypeScript/issues/28938
    , _extends({}, props, {
      google: google,
      googleMapsInstance: instance
    }));
  };
  WithGoogleMaps.contextTypes = {
    __ais_geo_search__google_maps__: PropTypes.shape({
      google: PropTypes.object,
      instance: PropTypes.object
    })
  };
  return WithGoogleMaps;
};
export default withGoogleMaps;